/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractEntity
 */
export interface ContractEntity {
    /**
     * 
     * @type {string}
     * @memberof ContractEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractEntity
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractEntity
     */
    authorizedEntity?: string;
}

export function ContractEntityFromJSON(json: any): ContractEntity {
    return ContractEntityFromJSONTyped(json, false);
}

export function ContractEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'authorizedEntity': !exists(json, 'authorizedEntity') ? undefined : json['authorizedEntity'],
    };
}

export function ContractEntityToJSON(value?: ContractEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'carePrincipalId': value.carePrincipalId,
        'authorizedEntity': value.authorizedEntity,
    };
}

